/**
 * State management constants and configuration
 */

export const CART_STORAGE_KEY = process.env.GATSBY_CART_NAME

export const STOREFRONT_CONFIG = {
  storeDomain: "https://" + process.env.GATSBY_SHOPIFY_STORE_URL,
  apiVersion: "2025-10",
  publicAccessToken: process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
}

export const ROLLBAR_CONFIG = {
  accessToken: process.env.GATSBY_ROLLBAR_KEY,
  environment: process.env.GATSBY_ROLLBAR_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  payload: {
    client: {
      javascript: {
        code_version: process.env.GATSBY_ROLLBAR_CODE_VERSION || "1.0.0",
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
}

export const CURRENCY_CONFIG = {
  id: "GBP",
  format: "£",
}

export const DEFAULT_ADDRESS = {
  address1: "",
  address2: "",
  city: "",
  locality: "",
  zip: "",
  country_code: "GB",
}

export const EMPTY_CALCULATION = {
  calculated: false,
  name: "",
  value: 0,
}

export const EMPTY_PROMO_CODE = {
  promo_code: "",
  applied: false,
  validCode: true,
  validated: true,
}
